import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=6f792258"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f792258')) {
      api.createRecord('6f792258', component.options)
    } else {
      api.reload('6f792258', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=6f792258", function () {
      api.rerender('6f792258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Title.vue"
export default component.exports